import React from "react"

import { sToc } from "../../styled/blog-post/toc"

const ToC = ({ toc: { items } }) => {
  const List = ({ items }) => (
    <sToc.List>
      {items &&
        items.map(item => (
          <>
            <sToc.Item key={item.url}>
              <a href={item.url}>{item.title}</a>
            </sToc.Item>
            <List items={item.items} />
          </>
        ))}
    </sToc.List>
  )

  return <List items={items} />
}

export default ToC
